/**
 * In-session pub-sub so group-invite sockets can refresh the merged inbox
 * without the inbox hook knowing about conversation sockets.
 */

type Listener = () => void;
const listeners = new Set<Listener>();

export function emitRecipientInvitesChanged(): void {
  for (const listener of [...listeners]) {
    try {
      listener();
    } catch {
      // A failing subscriber must not prevent the others from being notified.
    }
  }
}

export function onRecipientInvitesChanged(listener: Listener): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
